<template>
  <div class="layout_main_app">
    <app-header-view :routes="routes"></app-header-view>
    <transition>
      <router-view></router-view>
    </transition>
    <app-foot-view></app-foot-view>
  </div>
</template>

<script>
  import {constantRouterMapApp} from '@/router';
  import AppHeaderView from '../headerView/AppHeaderView';
  import AppFootView from '../headerView/AppFootView';

  export default {
    name: "Layout",
    components: {AppHeaderView, AppFootView},
    data() {
      return {
        activeIndex: 0,
        routes: constantRouterMapApp,
        time: ''
      }
    },
    computed: {
      // 获取登录用户信息
      currentName() {
        //由于vuex的状态存储是响应式的，所以从store实例中读取状态的最简单方法就是使用计算属性来返回某个状态：
        return sessionStorage.getItem("username")
      },

    },
    methods: {
      changActiveIndex(val, router) {
        this.activeIndex = val;
        this.$router.push({name: router})
      }
    },
    mounted() {
      this.$store.dispatch('setActiveIndex',this.$route.path.split("/")[2]);
      this.$store.dispatch('setActiveUrl',this.$route.path);
      this.$store.dispatch('setBreadcrumb',this.$route.matched.slice(-2));
      let data = new Date();
      let year = data.getFullYear();
      let month = data.getMonth() + 1 >= 10 ? data.getMonth() + 1 : '0' + (data.getMonth() + 1);
      let day = data.getDate() >= 10 ? data.getDate() : '0' + data.getDate();
      let week = data.getDay();
      switch (week) {
        case 1 :
          week = "星期一";
          break;
        case 2 :
          week = "星期二";
          break;
        case 3 :
          week = "星期三";
          break;
        case 4 :
          week = "星期四";
          break;
        case 5 :
          week = "星期五";
          break;
        case 6 :
          week = "星期六";
          break;
        case 0 :
          week = "星期日";
          break;
      }
      this.time = year + '年' + month + "月" + day + '日&nbsp;&nbsp;' + week;
    },
    watch: {
      $route: {
        handler: function (val, oldVal) {
          this.$store.dispatch('setBreadcrumb',val.matched.slice(-2));
          this.$store.dispatch('setActiveIndex',val.path.split("/")[2]);
          this.$store.dispatch('setActiveUrl',val.path);
        },
        // 深度观察监听
        deep: true
      }
    },
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/layout/AppLayout.vue